/**
 * Immutable list helpers for manual ordering UIs.
 */

/**
 * Move an element from one index to another. Returns a new array.
 * @template T
 * @param {T[]} arr
 * @param {number} from
 * @param {number} to
 * @returns {T[]}
 */
export function moveIndex(arr, from, to) {
    if (!Array.isArray(arr)) return [];
    const len = arr.length;
    if (from < 0 || from >= len || to < 0 || to >= len || from === to) {
        return arr.slice();
    }
    const next = arr.slice();
    const [item] = next.splice(from, 1);
    next.splice(to, 0, item);
    return next;
}

/**
 * Sort a copy of arr by getName(item), case-insensitive localeCompare.
 * @template T
 * @param {T[]} arr
 * @param {(item: T) => string} getName
 * @returns {T[]}
 */
export function alphabetizeBy(arr, getName) {
    if (!Array.isArray(arr)) return [];
    const get = typeof getName === 'function' ? getName : (x) => String(x ?? '');
    return arr.slice().sort((a, b) => {
        const na = String(get(a) ?? '').trim();
        const nb = String(get(b) ?? '').trim();
        return na.localeCompare(nb, undefined, { sensitivity: 'base' });
    });
}
